import '@onereach/styles/main-v3.css';

import { setupPermissions } from '@onereach/permissions-ui';
import { createApp } from 'vue';

import App from '@/App.vue';
import config from '@/config';
import i18n from '@/i18n';
import router from '@/router';
import SentryApi from '@/sentry';
import createPinia from '@/stores';
import useAuth from '@/stores/auth';

const app = createApp(App);

app.use(i18n);
app.use(createPinia());

app.use(setupPermissions({
  permissionsUrl: config.PERMISSIONS_API_URL,
  token: () => `USER ${useAuth().reactiveToken}`,
  userRole: () => useAuth().role,
  productName: 'billing',
  i18n,
}));
app.use(router);

SentryApi.init(app, router);

app.mount('#app');
